"use client";
import { useState } from "react";
import { FaWhatsapp, FaPhone, FaEnvelope, FaCopy } from "react-icons/fa";
import "./Support.css";

const Support = () => {
  const [copyAlert, setCopyAlert] = useState({ show: false, message: "" });

  const contactInfo = [
    {
      typeText: "Chat Us On WhatsApp",
      value: "+234-705-191-8116",
      icon: FaWhatsapp,
      action: () => window.open("https://wa.me/2347051918116", "_blank"),
      color: "#25D366",
    },
    {
      typeText: "Send Us Email (nimblebashsupport@nimblebash.com)",
      value: "nimblebashsupport@nimblebash.com",
      icon: FaEnvelope,
      action: () =>
        window.open("mailto:nimblebashsupport@nimblebash.com", "_blank"),
      color: "#EA4335",
    },
    {
      typeText: "Call Us (+234 705 191 8116)",
      value: "+234 705 191 8116",
      icon: FaPhone,
      action: () => window.open("tel:+2347051918116", "_blank"),
      color: "#4285F4",
    },
  ];

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);

    let message = "";
    if (type.includes("WhatsApp")) {
      message = "WhatsApp number copied!";
    } else if (type.includes("Email")) {
      message = "Email address copied!";
    } else if (type.includes("Call")) {
      message = "Phone number copied!";
    }

    setCopyAlert({ show: true, message });

    setTimeout(() => {
      setCopyAlert({ show: false, message: "" });
    }, 3000);
  };

  return (
    <div className="support-container">
      <div className="support-content">
        <div className="support-main">
          <h2 className="support-title">We're Here to Help!</h2>
          <p className="support-description">
            Need assistance? Our support team is available 24/7 to answer your
            questions and resolve any issues you might encounter. Reach out to
            us through any of the methods below, and we'll get back to you as
            soon as possible.
          </p>
          <div className="support-contact-options">
            {contactInfo.map((item, index) => (
              <div key={index} className="support-contact-option">
                <div className="support-contact-info" onClick={item.action}>
                  <div
                    className="support-contact-icon"
                    style={{ backgroundColor: item.color }}
                  >
                    <item.icon />
                  </div>
                  <span className="support-contact-text">{item.typeText}</span>
                </div>
                <button
                  className="support-copy-button"
                  onClick={() => handleCopy(item.value, item.typeText)}
                  title="Copy to clipboard"
                >
                  <FaCopy />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      {copyAlert.show && (
        <div className="support-copy-alert">
          <div className="support-copy-alert-content">
            <span>{copyAlert.message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Support;
